/*
 * Copyright (C) 2025.  SimpliCity Digital Inc - All Rights Reserved
 */

export const orgSettingsState = {
    websites: null,
};
